import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function STWhyChoose() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-2063">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-2064">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-2065">
          {/* Left Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[40%]" delay={200} data-id="element-2066">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-xl" data-id="element-2067">
              <img src="https://cdn.magicpatterns.com/uploads/759gZ63551QasgLbFTaA59/Rectangle-2506.jpg" alt="SkinTyte Skin Rejuvenation Results" className="w-full h-full object-cover" data-id="element-2068" />
            </div>
          </AnimateOnScroll>

          {/* Right Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[60%] text-center lg:text-left flex flex-col items-center lg:items-start" data-id="element-2069">
            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-2070">
              WHY CHOOSE BE CLINICAL FOR SKIN LAXITY
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-10" data-id="element-2071"></div>

            <div className="space-y-6 text-[#B0B0B0] text-[17px] leading-[1.8] font-body mb-10" data-id="element-2072">
              <p data-id="element-2073">
                At Be CLINICAL, we uphold a steadfast commitment to delivering
                unparalleled skincare solutions backed by expertise and
                innovation. When you choose Be CLINICAL for SkinTyte, you embark
                on a journey guided by our mantra of precision, efficacy, and
                excellence. Our team of providers led by Dr. Fiona Frie is not
                only highly knowledgeable but also deeply skilled in the latest
                technologies, ensuring that you receive the most comprehensive
                and advanced treatment available.
              </p>
              <p data-id="element-2074">
                With a focus on clinical expertise and cutting-edge technology,
                we strive to exceed your expectations and deliver transformative
                results, empowering you to embrace radiant, rejuvenated skin
                with confidence. We invite you to schedule your complimentary
                consultation today!
              </p>
            </div>

            <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-2075">
              BOOK CONSULT
            </Button>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}